import { render, staticRenderFns } from "./UiKid.vue?vue&type=template&id=6f642702&scoped=true"
import script from "./UiKid.vue?vue&type=script&lang=js"
export * from "./UiKid.vue?vue&type=script&lang=js"
import style0 from "./UiKid.vue?vue&type=style&index=0&id=6f642702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f642702",
  null
  
)

export default component.exports